import { render, staticRenderFns } from "./NotificationList.vue?vue&type=template&id=cff9b75e&scoped=true"
import script from "./NotificationList.vue?vue&type=script&lang=js"
export * from "./NotificationList.vue?vue&type=script&lang=js"
import style0 from "./NotificationList.vue?vue&type=style&index=0&id=cff9b75e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff9b75e",
  null
  
)

export default component.exports